<template lang="pug">
modal#backup-in-progress-modal(
  :noFooter='true'
  :title='$t("modal.backupInProgress.title")'
  @process='closeModal'
  ref='modal'
)
  p.text-center {{ $t('modal.backupInProgress.message') }}
  p.mt-3.mb-0(v-if='backup')
    strong {{ $t('modal.backupInProgress.lastBackup') }}:&nbsp;
    | {{ backup.created_at | dateTime }} {{ backup.created_at | time }}
  p.mb-0(v-if='backup')
    strong {{ $t('modal.backupInProgress.status') }}:&nbsp;
    | {{ getStatusText(backup.status) }}
    img.mt-4.mb-3.d-block.mx-auto(
      alt='backup-in-progress-warning'
      src='/img/ilustrations/application-warning.svg'
    )
  .modal-footer.p-0.d-flex.justify-content-end
    button#buttonColor.btn.btn-primary(@click='closeModal' type='button')
      | {{ $t('modal.backupInProgress.okButton') }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import BackupState from '@/enums/BackupState';

export default {
  name: 'BackupInProgressModal',
  components: {
    Modal,
  },
  data() {
    return {
      backup: null,
    };
  },
  methods: {
    getStatusText(status) {
      return BackupState.getText(status, this.$i18n);
    },
    open(backup) {
      this.backup = backup;
      this.$refs.modal.open();
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
